export class LoggingAnalyticsHandler {
  trackPageView(url) {
    
  }
}

export class GoogleAnalyticsHandler {
  constructor(ga) {
    if (process.env.NODE_ENV === 'development') {
      return;
    }
    if (typeof ga !== 'function') {
      throw new Error('Variable `ga` missing for Google Analytics');
    }
    this.ga = ga;
  }
  trackPageView(url) {
    // https://developers.google.com/analytics/devguides/collection/analyticsjs/single-page-applications#tracking_virtual_pageviews
    if (process.env.NODE_ENV === 'development') {
      return;
    }
    this.ga('set', 'page', url);
    this.ga('send', 'pageview');
  }
}
